import { render, staticRenderFns } from "./AppointmentSMSContent.vue?vue&type=template&id=90a657c8"
import script from "./AppointmentSMSContent.vue?vue&type=script&lang=js"
export * from "./AppointmentSMSContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports